import SecurityIPSetting from '../../../ts/components/tenant/SecurityIPSetting';
import translations from '../../translations';
import type { SecuritySettingsAPI } from '../../types/Tenant';
import type { UpdateTenant } from './TenantPage';

type SecurityProps = {
    securitySettings: SecuritySettingsAPI | null;
    updateTenant: UpdateTenant;
};

const Security = ({ securitySettings, updateTenant }: SecurityProps) => {
    const isRunRestrictedByIPRange = securitySettings?.isRunRestrictedByIPRange ?? false;
    const isDrawRestrictedByIPRange = securitySettings?.isDrawRestrictedByIPRange ?? false;
    const isAdminRestrictedByIPRange = securitySettings?.isAdminRestrictedByIPRange ?? false;
    const isPackagingRestrictedByIPRange =
        securitySettings?.isPackagingRestrictedByIPRange ?? false;
    const authorizedAdminIPRanges = securitySettings?.authorizedAdminIPRanges ?? [];
    const authorizedDrawIPRanges = securitySettings?.authorizedDrawIPRanges ?? [];
    const authorizedPackagingIPRanges = securitySettings?.authorizedPackagingIPRanges ?? [];
    const authorizedRunIPRanges = securitySettings?.authorizedRunIPRanges ?? [];

    return (
        <div className="form-group">
            <SecurityIPSetting
                ipRange="authorizedRunIPRanges"
                isActive={isRunRestrictedByIPRange}
                settingPropertyName="isRunRestrictedByIPRange"
                rangeEntries={authorizedRunIPRanges}
                labelText={translations.TENANT_security_ip_setting_run_restrictions_label}
                updateTenant={updateTenant}
            />
            <SecurityIPSetting
                ipRange="authorizedDrawIPRanges"
                isActive={isDrawRestrictedByIPRange}
                settingPropertyName="isDrawRestrictedByIPRange"
                rangeEntries={authorizedDrawIPRanges}
                labelText={translations.TENANT_security_ip_setting_draw_restrictions_label}
                updateTenant={updateTenant}
            />
            <SecurityIPSetting
                ipRange="authorizedAdminIPRanges"
                isActive={isAdminRestrictedByIPRange}
                settingPropertyName="isAdminRestrictedByIPRange"
                rangeEntries={authorizedAdminIPRanges}
                labelText={translations.TENANT_security_ip_setting_admin_restrictions_label}
                updateTenant={updateTenant}
            />
            <SecurityIPSetting
                ipRange="authorizedPackagingIPRanges"
                isActive={isPackagingRestrictedByIPRange}
                settingPropertyName="isPackagingRestrictedByIPRange"
                rangeEntries={authorizedPackagingIPRanges}
                labelText={translations.TENANT_security_ip_setting_package_restrictions_label}
                updateTenant={updateTenant}
            />
        </div>
    );
};

export default Security;
